/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Font_Preview_BodyInputs */

const en_onboarding_font_preview_body = /** @type {(inputs: Onboarding_Font_Preview_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`using multilabel classification. We do not use a softmax as we found it is unnecessary for good performance, instead we simply use independent logistic classifiers. During training we use binary cross-entropy loss for the class predictions.`)
};

const es_onboarding_font_preview_body = /** @type {(inputs: Onboarding_Font_Preview_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`usando clasificación multietiqueta. No usamos softmax porque descubrimos que no es necesario para obtener buen rendimiento; en su lugar, usamos clasificadores logísticos independientes. Durante el entrenamiento usamos pérdida de entropía cruzada binaria para las predicciones de clase.`)
};

/**
* | output |
* | --- |
* | "using multilabel classification. We do not use a softmax as we found it is unnecessary for good performance, instead we simply use independent logistic class..." |
*
* @param {Onboarding_Font_Preview_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_font_preview_body = /** @type {((inputs?: Onboarding_Font_Preview_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Font_Preview_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_font_preview_body(inputs)
	return en_onboarding_font_preview_body(inputs)
});